// extracted by css-extract-rspack-plugin
export default {"label":"bidAdjustmentsSetting_label__dKfWi"};